import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { format } from 'date-fns';
import ToolTipIcon from '../ToolTipIcon/ToolTipIcon';
import ToolTip from '../ToolTipIcon/ToolTip';
import SSTable from '../SSTable/SSTable';
import SSColumn from '../SSTable/SSColumn';
import AssetImage from '../Assets/AssetImage';
import { formatTime } from '../../utils/formatUnits';

export default class PlaylistFilesTable extends Component {
  getPosition = (item, index) => (
    <div className=" h-[45px] w-full justify-center flex items-center box-border">
      <span className="circle circle-md text-dark-night">{index + 1}</span>{' '}
    </div>
  );

  getPreview = item => (
    <div className=" flex mt-[2px] h-[45px] justify-start box-border overflow-hidden">
      <AssetImage type="video" item={item} />
      <p />
    </div>
  );

  getName = item => {
    let { tags = [] } = item || {};

    if (!tags || !Array.isArray(tags)) {
      tags = [];
    }

    return (
      <div className="w-full justify-start flex flex-col items-start box-border">
        <div className="flex items-center w-full">
          <ToolTip toolText={item.parent}>
            <Link to={`/assets/${item.id}`}>{item.name}</Link>
          </ToolTip>
        </div>
        {tags.length > 0 && (
          <div data-test="playlist-item-tags" className="flex flex-wrap gap-1 mt-1">
            {tags.map(tag => (
              <span
                key={tag}
                className="inline-flex items-center rounded-md bg-orange-50 px-2 py-1 text-xs font-medium text-sunrise inset-ring inset-ring-orange-600/20"
              >
                {tag}
              </span>
            ))}
          </div>
        )}
      </div>
    );
  };

  getDimensions = item => `${item.width} x ${item.height}`;

  getDuration = item => {
    const { duration } = item;

    if (!duration || duration <= 0) {
      return null;
    }

    const [secs, ms] = formatTime(duration / 1000).split('.');

    return (
      <div>
        {secs}
        {ms ? <span className="text-light !inline">.{ms}</span> : null}
      </div>
    );
  };

  getRemove = (item, index) => {
    const { onRemoveFile } = this.props;

    return (
      <ToolTipIcon toolText="Remove">
        <button
          type="button"
          onClick={() => onRemoveFile(index)}
          className="h-[34px] w-[34px] border-2 flex justify-center items-center rounded-lg"
        >
          <img
            src="/assets/images/icons/black_delete_icon.svg"
            alt="delete item"
            className="h-[19.4px] w-[15.63px]"
          />
        </button>
      </ToolTipIcon>
    );
  };

  getValidity = item => {
    if (!item.validityEnabled) {
      return 'Always';
    }

    return `${format(new Date(item.validityStart), 'dd/MM/yyyy')} - ${format(
      new Date(item.validityEnd),
      'dd/MM/yyyy',
    )}`;
  };

  render() {
    const {
      auth: {
        user: {
          permissions: { Writer },
        },
      },
      data,
      onSort,
    } = this.props;

    if (!data) {
      return null;
    }

    return (
      <SSTable
        className="responsive table-playlist mt-8"
        data={data}
        headerHeight={50}
        rowHeight={45}
        rowsCount={data.length - 1}
        onSort={onSort}
        selectable
        sortable={Writer}
        zebra
      >
        <SSColumn containerClasses="!w-[25px] p-2" fixedWidth="25px" cell={this.getPosition} />
        <SSColumn containerClasses="!w-[120px] p-2" header="Preview" cell={this.getPreview} />
        <SSColumn header="Name" containerClasses="p-2 " cell={this.getName} />
        <SSColumn containerClasses="!w-[105px] p-2" header="Dimensions" cell={this.getDimensions} />
        <SSColumn containerClasses="!w-[125px] p-2" header="Duration" cell={this.getDuration} />
        <SSColumn
          containerClasses="!w-[125px] p-2"
          header="Validity Period"
          cell={this.getValidity}
        />
        {Writer && <SSColumn fixedWidth="35px" header="" cell={this.getRemove} />}
      </SSTable>
    );
  }
}

PlaylistFilesTable.propTypes = {
  auth: PropTypes.object.isRequired,
  data: PropTypes.array,
  onSort: PropTypes.func.isRequired,
  onRemoveFile: PropTypes.func.isRequired,
};
